import { useEffect, useState } from 'react'

type WindowSize = 'xs' | 'md' | 'lg' | 'xl'

const useSizeWindow = (): WindowSize => {
  const isBrowser = typeof window !== 'undefined'
  const getWidth = (): WindowSize => {
    if (isBrowser) {
      const { innerWidth: width } = window
      if (width < 576) {
        return 'xs'
      } else if (width < 992) {
        return 'md'
      } else if (width < 1200) {
        return 'lg'
      } else if (width > 1200) {
        return 'xl'
      }
      return 'lg'
    }
  }

  const [width, setWidth] = useState<WindowSize>(getWidth())
  const handleSize = (): void => setWidth(getWidth())

  useEffect(() => {
    window.addEventListener('resize', handleSize)
    return () => window.removeEventListener('resize', handleSize)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return width
}

export default useSizeWindow
